import React from "react";
import classNames from "classnames";
import classes from "./SpinnerLoader.scss";

const SpinnerLoader = ({
  size = 16,
  borderWidth = 1.3,
  borderColor = "var(--border-secondary)",
  borderTopColor = "var(--neutral-500)",
  speed = 1,
  className = "",
}) => {
  const style = {
    width: size,
    height: size,
    borderWidth: `${borderWidth}px`,
    borderColor: borderColor,
    borderTopColor: borderTopColor,
    animationDuration: `${speed}s`,
  };

  return (
    <span className={classNames(classes.spinner, className)} style={style} />
  );
};

export default SpinnerLoader;
